module.exports = __webpack_public_path__ + "img/OTMS_Onboarding_HeaderAnim_LV.fd8622e4.png";